(function ($, window, _, eventhub, cssCreator) {
    'use strict';
    var pluginName = 'PMSelectH';
    var getCardType = function (name) {
        if (name && _.isString(name)) {
            return name.substring(0, name.indexOf('_my_methods'));
        }
        return '';
    };
	var ghostClickElapsedTime = 50;
	var _lastEventTimestamp;
	var constants = {
		onlyOnePmClassName   : 'lonely',
		groupOpenClassName   : 'g_open',
		groupActiveClassName : 'g_active',
		groupUlClassName     : '_g_ul',
		showGalleryClassName : 'show_gallery',
		hasApplePayOnTopClassName : 'withApplePay',
		supportedImageMimeType : {
			"image/gif"     : 1,
			"image/jpeg"    : 1,
			"image/png"     : 1,
			"image/svg+xml" : 1
		},
		resourceTypeUrl : 'url',
		extractedPMs    : {
			"ppp_ApplePay" : 1
		},
		fakeUpos    : {
			"ppp_ApplePay"  : 1,
			"ppp_GooglePay" : 1
		}
	};

    var defaults = {
		enableGrouping          : false,
		enableGroupAutoClosing  : false,
	    allowActiveGroupClosing : false,
		applySeparator			: false,
		pm_order_prefix         : '', // when the plugin is used as a sub gallery
        regExCardPattern        : /\((\d{4})\)|\d\*{4}(\d{4})|\d\*{3}\s+\*{4}\s+\*{4}\s+(\d{4})/,	// matches (1234) and 3****1234 and 1*** **** **** 3567
        asteriskTemplate        : "*",
        mainTemplate 	        : '<div id="scroller"><ul class="pm-list pms"></ul></div>',
        groupWrapTemplate       : '<ul class="grp "></ul>',
        groupToggleIconTemplate : '<div class="group_icon"></div>',
        ccCardTemplate	 : '<div class="cc-card-medium cc_card"><div class="x-middle visa cc-first"></div><div class="x-middle master_card"></div><div class="x-middle cc-third"></div><div class="x-middle cc-fourth"></div></div>',
        dotnavWrapper    : '<div class="<%- selector %>" />',

	    appleNavTemplate  :
		    '<div class="apple_pay_wrapp hidden">' +
                '<div class="apple">' +
                    '<div class="btn_container">' +
                        '<div class="pm-logo ">' +
		                    '<div class="pm-logo ppp_applepay"></div>' +
                        '</div>' +
                        '<div class="text"><%- t("ppp_ApplePay")%></div>' +
                    '</div>' +
                '</div>' +
                '<p class="or_separator"><span><%- t("applepay_or_separator")%></span></p>' +
                '<div class="other">' +
		            '<div class="btn_container">' +
                        '<div class="pm-logo other_pms" ></div>' +
		                '<div class="text"><%- t("other_pms")%></div>' +
                    '</div>' +
                '</div>' +
		    '</div>'
	    ,
        templates    	 : {
            separatorTemplate : _.template('<li data-value="" data-type="" id="pmSelectH_separator" class="pmSelectH_sep"><div class="_li"><div class="separator-vr"></div></div></li>'),
            itemPMTemplate : _.template('<li data-value="<%-itemId %>" data-type="<%- type %>"><div class="_li"><%=itemTemplate%></div></li>'),
            userPMTemplate : _.template('<div class="<%-classPrefix%> pm_container"><div class="<%-classPrefix%> pm_available " title="<%- ((details == \'&nbsp;\') ? \'\' : details) %>"><div class="upm-logo <%-showClass%>"></div><%if (details !== \'&nbsp;\'){ %><div class="<%-classPrefix%> pm-details"><%=details%></div><% } %></div><div class="<%-classPrefix%> pm_side_status"></div></div>'),
            myPMTemplate   : _.template('<div class="<%=classPrefix%> pm_container"><div class="<%=classPrefix%> pm_available" title="<%=label%>"><div class="pm-logo <%-showClass%>"><% if (hasNoClass) { %><%=label%><%}%></div></div><div class="<%=classPrefix%> pm_side_status"></div></div>'),
            controlsTemplate: _.template("<div class='iscroll-controls-horizontal'><button type='button' class='left'>Left</button><button type='button' class='right'>Right</button></div>"),
            dotnavTemplate : _.template('<% for (var i = 0; i < count; i++) { %><span data-type="<%- type %>"></span><% } %>')
        },
	    customCssObjCreator : function(imgUrl, className){ return {background: "url('"+ imgUrl+ "') no-repeat center center;"}; },
		customCssRuleSelectorSufix: '', // '' | '::after' | '::before',
		isScrollEnabled  : true,
        scrollerSettings : {
            scrollX          : true,
            scrollY          : false,
            mouseWheel       : true,
            scrollbars       : false, // true,
            tap              : true,
            snap             : false, // true,
			bindToWrapper    : true,
            shrinkScrollbars : 'scale'
        },
		showControls         : false,
		staticControls	     : false,
		itemContainerTagName : 'li',
		onClickSelector      : 'li',
		showUserPMs          : true,
		showMerchantPM       : true,
		prioritizePMs		 : [], // ["ppp_ApplePay", "ppp_GooglePay"],
		prioritizeFakeUpos	 : false,
		showApplePayInline 	 : false,
		reduceApplePayPriority : false,
	    activeElementClass   : 'selected',
        scrollMargin         : 20,
        showDotnav           : false,
        dotnavClassSelector  : 'iscroll-dotnav-horizontal',
        dotnavActiveClass    : 'selected',
        onClickDotnavSelector: 'span',
        direction            : 'ltr' //  ( 'ltr'  | 'rtl' )
    };


	var handleClicks = function (mainElm, options, ctx) {
		var self = ctx;
		var allowClickSamePM = options.allowClickSamePM;

		mainElm.on('click tap', options.onClickSelector, function (evt, data) {
			var dataToSend = null;
			var currentTime = (new Date()).getTime();

			// ghost click events
			if (currentTime - _lastEventTimestamp < ghostClickElapsedTime) {
				_lastEventTimestamp = currentTime;
				return true;
			}
			var liElm = $(evt.target).closest(options.itemContainerTagName);
			var uniqueId = liElm.data('value');
			var isAlreadySelected = liElm.hasClass(options.activeElementClass);
			if (self.Groups && self.Groups[uniqueId]) {
				self.manageGroupedPMs(uniqueId, liElm);
				_lastEventTimestamp = currentTime;
				return;
			}
			if (!isAlreadySelected || allowClickSamePM) {
				if (isNaN(parseInt(uniqueId, 10))) {
					dataToSend = self.options.pm_data[uniqueId];
				} else {
					dataToSend = self.options.user_pm_data[_.findIndex(self.options.user_pm_data, {uniqueId : uniqueId})];
				}
				dataToSend.pmPosition = self.order[uniqueId];
				self.updateCurrentState(dataToSend, liElm);
				self.unselect(true);
				self.select(liElm);
				eventhub.publish('select-pm', [dataToSend, self, this, data]);
			} else {
				eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId}, self, this]);
			}
			_lastEventTimestamp = currentTime;
			evt.preventDefault();
		});
	};

	function Plugin(element, options) {
		options = options || {};
		if (!options.onClickSelector && options.itemContainerTagName) {
			options.onClickSelector = options.itemContainerTagName.toString();
		}
		this.options = $.extend(true, {}, defaults, options);
		this.hasApplePay = false;
		this.count_upm = 0;
		this.count_pm = 0;
		this.$mainElement = $(element);

		this.$appleNav = $(_.template(this.options.appleNavTemplate)());
		this.$appleBtn = this.$appleNav.find('.apple');
		this.$mainElement.append(this.$appleNav);

		var $newWrapper = $('<div class="list-container" />');
		this.$mainElement.append($newWrapper);
		this.element = $newWrapper[0];
		this.$element = $newWrapper;

		this.template = _.template(this.options.mainTemplate);
		this.wrapper = $(this.template(this.options));
		this.pmList = this.wrapper.find('ul');
		this.updateControlButtons = function () {/* This is intentional*/};

		this.$element.empty();
		this.$element.append(this.wrapper);
		this.init();

	}

    Plugin.prototype.init = function () {
		var self = this;
        cssCreator.setup(this.options.cssCreator);
        if(this.options.showMerchantPM) {
            eventhub.subscribe('pm-available', function (data) {
                this.updateData('pm', data);
            }, this);
        }
        if(this.options.showUserPMs) {
            eventhub.subscribe('user-pm-available', function (data) {
                this.updateData('user_pm', data);
            }, this);
        }
        eventhub.subscribe('dr-select-pm', function (data) {
            var uniqueId = (data.type && data.type === 'int') ? parseInt(data.uniqueId) : data.uniqueId;
            this.handleDR(uniqueId, data.type, data.manual, data.allowApplePayAutoSelect);
        }, this);
        eventhub.subscribe('app.event.PMSelectH.unselectPM', function() {
            this.unselect();
        }, this);
        handleClicks(this.pmList, this.options, this);

	    if(self.options.showControls){
		    _setupControls(self);
	    }
		_fixScrollBehavior(self);
        $(window).resize( function(){
	        self.updateScroll();
	        self.updateControlButtons();
        });
        this.addAppleEvents();
    };

	Plugin.prototype.addAppleEvents = function () {
		var self = this;
		if(!self.options.showApplePayInline) {
			self.$appleNav.on('click tab', ".apple", function (e) {
				self.selectApplePay();
			});
			self.$appleNav.one('click tab', ".other", function (e) {
				self.$appleNav.addClass(constants.showGalleryClassName);
			});
		} else if (self.$appleNav) {
			self.$appleNav.addClass(constants.showGalleryClassName);
		}
	};

	Plugin.prototype.selectApplePay = function (manual) {
		var self = this;
        var $el = $(self.options.itemContainerTagName + '[data-value="ppp_ApplePay"]', self.wrapper);
        if($el.length > 0) {
            var $targetElm = $(self.options.onClickSelector, $el);
            if ($targetElm.length === 0) {
                $targetElm = $el;
            }
            $targetElm.trigger('click', manual);
            if(self.hasApplePay && !self.options.showApplePayInline){
	            $(".apple", self.$appleNav).addClass(self.options.activeElementClass);
            }
            return true;
        } else {
	        self.unselect();
        }
	};

	Plugin.prototype.handleDR = function (uniqueId, idType, manual, allowApplePayAutoSelect) {
		var self = this;
		var $el;
		if (self.hasApplePay && allowApplePayAutoSelect && (!(self.options.user_pm_data && self.options.user_pm_data.length) || !self.options.reduceApplePayPriority)) {
			self.selectApplePay(manual);
			return;
		} else if (uniqueId === "auto_select" && idType === "auto_select") {
			$el = $(this.options.itemContainerTagName + '[data-value]', this.wrapper).first();
		} else if (uniqueId === "auto_select" && idType === "pm") {
			$el = $(this.options.itemContainerTagName + '[data-value][data-type="pm"]', this.wrapper).first();
		} else {
			$el = $(this.options.itemContainerTagName + '[data-value="' + uniqueId + '"]', this.wrapper);
		}
		if ($el.length) {
			var $targetElm = $(this.options.onClickSelector, $el);
			if ($targetElm.length === 0) {
				$targetElm = $el;
			}
			$targetElm.trigger('click', manual);
			// Fix (ensure proper scroll width)
			// when Gallery has been hidden/invisible ( => maxScrollX == 0) and needs to be updated
			if (!this.scroller || this.scroller.isFake || this.scroller.maxScrollX == 0) {
				this.updateScroll();
			} else {
				this.scroller.refresh();
			}
			this.scroller && this.scroller.scrollToElement($el[0], 0, true);
			if(self.hasApplePay && self.$appleNav && (uniqueId != 'ppp_ApplePay' || self.options.showApplePayInline)){
				self.$appleNav.addClass(constants.showGalleryClassName);
			}
		} else {
			eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason : "incorrect_id"}, self, this]);
		}
	};

	Plugin.prototype.closeGroup = function (groupId) {
		var self = this;
		if (groupId && self.Groups && self.Groups[groupId]) {
			self.Groups[groupId].$elm.removeClass(constants.groupOpenClassName);
			self.Groups[groupId].$elms.addClass('hidden');
			if (self.selected && self.selected.groupId === groupId) {
				self.selected.$elm.removeClass('hidden');
			}
			self.updateScroll();
		}
	};

	Plugin.prototype.openGroup = function (groupId) {
		var self = this;
		if (groupId && self.Groups && self.Groups[groupId]) {
			self.Groups[groupId].$elm.addClass(constants.groupOpenClassName);
			self.Groups[groupId].$elms.removeClass('hidden');
			self.updateScroll();
		}
	};

	Plugin.prototype.manageGroupedPMs = function (groupId, $liGroupElm) {
		var self = this;
		if (groupId && self.Groups[groupId] && self.Groups[groupId].pm_list.length) {
			if ($liGroupElm && $liGroupElm.hasClass(constants.groupOpenClassName)) {
				if (self.options.allowActiveGroupClosing || (self.selected && self.selected.groupId !== groupId)) {
					self.closeGroup(groupId);
				}
			} else {
				self.openGroup(groupId)
			}
		}
	};

    Plugin.prototype.select = function ($liElm) {
        var self = this;
	    var groupId = (self.selected && self.selected.groupId);
	    $liElm.addClass(self.options.activeElementClass);
	    $liElm.find('.pm_side_status').addClass('arrow-div');
	    if (self.options.showDotnav) {
		    var $dotnav = self.$element.nextAll('.' + self.options.dotnavClassSelector);
		    if ($dotnav.length) {
			    var idx = $liElm.index();
			    $dotnav.children().eq(idx).addClass(self.options.dotnavActiveClass);
		    }
	    }
	    // GROUPS
	    if (self.options.enableGrouping && self.Groups && groupId) {
		    self.Groups[groupId].$elm.addClass(constants.groupActiveClassName);
		    if (self.options.allowActiveGroupClosing && self.options.enableGroupAutoClosing) {
			    self.closeGroup(groupId);
		    } else if(self.selected && self.selected.$elm.hasClass('hidden')){
			    self.openGroup(groupId);
		    }
	    }
    };

    Plugin.prototype.unselect = function (isCurrentStateUpdated) {
	    var self = this;
	    var activeElementClass = this.options.activeElementClass;
	    self.$appleBtn.removeClass(activeElementClass);
		self.pmList.find('.' + activeElementClass).removeClass(activeElementClass).find('.pm_side_status').removeClass('arrow-div');
	    if (self.options.showDotnav) {
		    self.wrapper.parent().nextAll('.' + self.options.dotnavClassSelector).find('.' + self.options.dotnavActiveClass).removeClass(self.options.dotnavActiveClass);
	    }
	    if(!isCurrentStateUpdated){
		    self.updateCurrentState();
	    }
	    // GROUPS
	    if (self.options.enableGrouping) {
		    var $activeGroupElm = self.pmList.find('.' + constants.groupActiveClassName),
			    groupIsOpen, lastActiveGroupId;
		    if ($activeGroupElm.length) {
			    groupIsOpen = $activeGroupElm.hasClass(constants.groupOpenClassName);
			    lastActiveGroupId = $activeGroupElm.attr('data-value');
			    $activeGroupElm.removeClass(constants.groupActiveClassName);
			    if (!groupIsOpen && (self.selected && self.selected.groupId !== lastActiveGroupId)) {
				    self.closeGroup(lastActiveGroupId);
			    }
		    }
	    }
    };

    Plugin.prototype.setupDotnav = function(type, count) {
        var self = this;
        var opt = this.options;
        var pmScroller = this.scroller;
        var wrapper = this.scroller.wrapper;
        var parent = $(wrapper).parent();
        var duration = 1000;
        var easing = IScroll.utils.ease.quadratic;

        if (!self.$element.nextAll('.' + opt.dotnavClassSelector).length) {
            var dotnavHtml =  _.template(opt.dotnavWrapper);
            $(parent).append(dotnavHtml({
                selector: opt.dotnavClassSelector
            }));
        }
        var $dotnav = self.$element.nextAll('.' + opt.dotnavClassSelector);
        var tpl = this.options.templates.dotnavTemplate;
        if (type === 'user_pm') {
            $dotnav.find('[data-type="user_pm"]').remove();
            $dotnav.prepend(tpl({
                count: count,
                type: type
            }));
        } else if (type === 'pm') {
            $dotnav.find('[data-type="pm"]').remove();
            $dotnav.append(tpl({
                count: count,
                type: type
            }));
        }
        $(wrapper).addClass('iscroll-dotnav');
        $(parent).on('click', opt.onClickDotnavSelector, function(e) {
            $dotnav.children().removeClass(opt.dotnavActiveClass);
            $(this).addClass(opt.dotnavActiveClass);
            var idx = $(this).index();
            var $item = self.$element.find(opt.itemContainerTagName).eq(idx)[0];
            pmScroller.scrollToElement($item, duration, true, true, easing);
            $item.click();
        });
    };

	Plugin.prototype.updateCurrentState = function (data, liElm) {
		var self = this;
		if (data) {
			self.selected = $.extend(true, {}, data);
			self.selected.$elm = liElm;
			self.selected.$groupElm = self.Groups && data.groupId && self.Groups[data.groupId] && self.Groups[data.groupId].$elm;
		} else {
			self.selected = {};
		}
	};

	Plugin.prototype.updateGroupsDomRef = function () {
		var self = this;
		if (self.options.enableGrouping && self.Groups) {
			_.each(self.Groups, function (group) {
				if (group && !group.$elm) {
					group.$elm = self.pmList.find(self.options.itemContainerTagName + '[data-value="' + group.uniqueId + '"]');
					group.$elms = self.pmList.find(self.options.itemContainerTagName + '[data-group="' + group.uniqueId + '"]');
				}
			});
		}
	};

	Plugin.prototype.prioritizePms = function () {
		var self = this;
		var len = self.options.prioritizePMs && self.options.prioritizePMs.length || 0;
		for (var i = len - 1; i >= 0; i--) {
			if(self.options.prioritizeFakeUpos && self._fakeUpos && self._fakeUpos[self.options.prioritizePMs[i]]){
				_changeDomElmPosition(self._fakeUpos[self.options.prioritizePMs[i]]);
			}
			_changeDomElmPosition(self.options.prioritizePMs[i]);
		}

		function _changeDomElmPosition(pmName) {
			var $elm = self.pmList.find(self.options.itemContainerTagName + '[data-value="' + pmName + '"]');
			if ($elm.length) {
				_prependTo(self.pmList, $elm, self.options.direction);
			}
		}
	};

	Plugin.prototype.updatePmPosition = function () {
		var self = this;
		var order = {};
		var items = self.pmList.find(self.options.itemContainerTagName + '[data-value]').not("[data-group]");
		_findOrder(items, self.options.pm_order_prefix);
		self.order = order;

		function _findOrder(items, prefix, subPrefix) {
			prefix = prefix ? prefix + "." : '';
			subPrefix = subPrefix ? subPrefix + "." : '';
			var count = 0;
			var upoCount = 0;
			var arr = (self.options.direction === 'rtl') ? items.toArray().reverse() : items.toArray();
			_.each(arr, function (item, idx) {
				var $i = $(item);
				var id = $i.attr("data-value");
				var isUpo = $i.attr("data-type") === "user_pm";
				var pos, subPos;
				if (isUpo) {
					pos = prefix + (++count);
					subPos = '' + (++upoCount);
				} else {
					pos = prefix + (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0' : ++count);
					subPos = (id === 'ppp_ApplePay' && !self.options.showApplePayInline) ? '0' : subPrefix + (count - upoCount);
				}
				order[id] = {absolute: pos, relative: subPos};
				if ($i.hasClass("pm_group")) {
					var pms = $i.find(self.options.itemContainerTagName + '[data-group="' + id + '"]');
					_findOrder(pms, pos, subPos);
				}
			});
		}
	};

	Plugin.prototype.updateData = function (data_type, data) {
		var self = this;
		var currentData = self[data_type] && self[data_type](data) || [];

		self.options[data_type + '_data'] = currentData;
		self.render(self.pmList, data_type);
		self.prioritizePms();
		self.updateGroupsDomRef();
		self.updatePmPosition();
		if(self.options.applySeparator && !$('#pmSelectH_separator').length) {
			var tpl = _.isString(self.options.templates.separatorTemplate) ? _.template(self.options.templates.separatorTemplate) : self.options.templates.separatorTemplate;
			var selector = self.options.direction === "ltr" ? 'li[data-type="user_pm"]+li[data-type="pm"]' : 'li[data-type="pm"]+li[data-type="user_pm"]';
			$(selector).before($(tpl()));
		}
		_handleApplePayClasses(self, data_type);
		if (self.options.ccCardTemplate) {
			$('.pm-logo.cc_card, .pm-logo.dc_card', this.wrapper).html(this.options.ccCardTemplate);
		}
		self.updateScroll();
		if (self.options.showDotnav) {
			self.setupDotnav(data_type, _.size(currentData));
		}

		eventhub.publish('app.event.pmselecth.postRender', [{data_type : data_type}]);
		eventhub.publish('app.event.gallery.postRender', [{data_type : data_type, plugin : 'pmselecth'}]);
	};

	Plugin.prototype.user_pm = function (userPMArray) {
		var self = this;
		var userPMData = $.extend(true, {}, userPMArray);
		var regExCardPattern = self.options.regExCardPattern;
		self.count_upm = 0;
		self._fakeUpos = {};
		return _.map(userPMData, function (item) {
			var iframe = null;
			var showClass = "";
			var details = "";
			var fee = item.customFees || {};
			var issuer = item.cardIssuer;
			var uniqueId = parseInt(item.userPaymentOptionId, 10) || -1;
			var url = _getUrl(item.metadata);

			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}

			if (regExCardPattern.test(item.name)) {
				details = self.options.asteriskTemplate + (item.name.match(regExCardPattern)[1] || item.name.match(regExCardPattern)[2] || item.name.match(regExCardPattern)[3]);
				showClass = item.type || item.card_type || getCardType(item.className) || item.paymentOptionName;
				issuer = issuer || showClass;
				// Hack for WD
				if (item.paymentOptionName === "visa_checkout") {
					showClass = item.paymentOptionName;
				}
			} else {
				showClass = item.paymentOptionName || item.type || item.card_type || getCardType(item.className);
				details = item.name;
				issuer = issuer || showClass;
			}
			showClass = showClass.toLowerCase() + (url ? '_' + uniqueId + '_modified' : '');
			self.count_upm++;
			if (item.paymentOptionName === 'apmgw_MuchBetter') {
				details = details.replace('-', '');
			}
			if (constants.fakeUpos[item.paymentOptionName]) {
				self._fakeUpos[item.paymentOptionName] = uniqueId;
			}
			return {
				uniqueId           : uniqueId,
				label              : item.displayPaymentOptionName || '',
				name               : item.paymentOptionName || '',
				isIframe           : iframe,
				showClass          : showClass,
				details            : _.escape(details) || '&nbsp;',
				feeValue           : fee.feeValue,
				feeValueType       : fee.feeValueType,
				feeType            : fee.feeType,
				rawData            : item || {},
				issuer             : issuer,
				imgUrl             : url || '',
				classPrefix        : 'upm',
				netDeposit         : item.netDepositValue || '',
				verificationStatus : item.verificationStatus || '',
				isLastUsedAccount  : item.isLastUsedAccount || '',
				cardExpiryDate     : item.cardExpiryDate || '',
				additionalClass    : item.additionalClass || ''
			};
		});
	};

	Plugin.prototype.pm = function (merchantPMArray) {
		var self = this;
		var merchantPMData = $.extend(true, {}, merchantPMArray);
		var retObj = {};
		self.hasApplePay = false;
		self.Groups = {};
		self.count_pm = 0;
		_.each(_.map(merchantPMData, function (item, idx, arr) {
			var details = "";
			var showClass = (item.value || '').toLowerCase();
			var fee = (item.attributes && item.attributes.customFees || {});
			var iframe = null;
			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}
			if (showClass === 'ppp_applepay') {
				self.hasApplePay = true;
			}
			if (item.groupId && !self.Groups[item.groupId]) {
				self.Groups[item.groupId] = _createGroup(item);
			}
			self.count_pm++;
			return {
				uniqueId        : item.value,
				label           : item.label,
				name            : showClass,
				isIframe        : iframe,
				showClass       : showClass,
				details         : details || '',
				feeValue        : fee.feeValue,
				feeValueType    : fee.feeValueType,
				feeType         : fee.feeType,
				promotedPM	    : item.attributes.promotedPM,
				additionalClass : item.attributes && item.attributes.additionalClass || '',
				rawData         : item,
				classPrefix     : 'pm',
				groupId         : self.options.enableGrouping && item.groupId
			};
		}), function (elm) {
			if (self.options.enableGrouping && elm.groupId && self.Groups[elm.groupId]) {
				if (!retObj[elm.groupId]) {
					retObj[elm.groupId] = self.Groups[elm.groupId];
				}
				retObj[elm.groupId].pm_list.push(elm);
			}
			retObj[elm.uniqueId] = elm;
		});
		return retObj;
	};

	Plugin.prototype.updateWidth = function () {
		function _setElmWidth($el) {
			var w = 0, blw, brw;
			$el.children().each(function () {
				var $this = $(this);
				if (!$this.hasClass('hidden')) {
					w += $this.outerWidth(true);
				}
			});
			blw = parseFloat($el.css('border-left-width'));
			brw = parseFloat($el.css('border-right-width'));
			w += (blw || 0) + (brw || 0);
			w = Math.ceil(w);
			$el.css('width', w + 'px');
			return w;
		}

		var totalLength = 0;
		var self = this;
		self.pmList.find('> ' + self.options.itemContainerTagName).each(function () {
			var $this = $(this);
			if (self.options.enableGrouping && $this.hasClass('pm_group')) {
				var $ul = $this.find('[data-role="groupItemsHolder"]');
				_setElmWidth($ul);
				_setElmWidth($this);
			}

			var thisStyles = window.getComputedStyle(this) || this.currentStyle;
			var margins = (parseFloat(thisStyles.marginLeft) || 0) + (parseFloat(thisStyles.marginRight) || 0);
			totalLength += Math.ceil(this.getBoundingClientRect().width + margins);
			/* $this.outerWidth(true) returns int rounded down (in Google Chrome), so we use this.getBoundingClientRect().width to get the decimal value and then round it up,
			   but this.getBoundingClientRect().width returns the width w/o margins so we need to get the margins too,
			   margins aways come in px (like that: 0px), because we take the computed styles */
		});
		self.wrapper.css('width',  Math.ceil(totalLength) + 'px');
	};

	Plugin.prototype.updateScroll = function () {
		var self = this;
		self.updateWidth();
		var fakeScrollObj = function () {
			this.isFake = true;
			this.refresh = _.identity;
			this.scrollToElement = _.identity;
			this.scrollTo = _.identity;
			this.destroy = _.identity;
			this.scrollBy = _.identity;
			this.on = _.identity;
		};
		var pmScroller = self.scroller;
		if (pmScroller && !pmScroller.isFake) {
			var $wrapper = $(pmScroller.wrapper);
			var parent = $wrapper.parent();
			pmScroller.refresh();
			if (pmScroller.scrollerWidth > $wrapper.width()) {
				$('.iScrollLoneScrollbar', parent).show();
			} else {
				$('.iScrollLoneScrollbar', parent).hide();
				pmScroller.destroy();
				self.scroller = new fakeScrollObj(self.element, self.options.scrollerSettings);
			}
		} else if (self.options.isScrollEnabled && (self.wrapper.width() > self.$element.width())) {
			self.scroller = new IScroll(self.element, self.options.scrollerSettings);
		} else {
			self.scroller = new fakeScrollObj(self.element, self.options.scrollerSettings);
		}
		self.updateControlButtons();
		_addScrollEndListener(self);
	};

	Plugin.prototype.render = function (currentListElm, data_type) {
		function _renderItem(item, dataType, tpl) {
			var $elm = $(self.options.templates.itemPMTemplate({
				itemId       : item.uniqueId,
				itemTemplate : tpl(item),
				type         : dataType
			}));
			if (item.groupId) {
				$elm.attr('data-group', item.groupId).addClass('hidden');
			}
			if (item.isPmGroup) {
				$elm.addClass('pm_group');
			}
			if (item.promotedPM) {
				$elm.addClass("promotedPM");
			}
			if (item.additionalClass) {
				$elm.addClass(item.additionalClass);
			}
			return $elm;
		}

		function _listItems(parentElm, data, dataType, isGroupMember) {
			var itemContentTemplate = {
				user_pm : (_.isString(self.options.templates.userPMTemplate) ? _.template(self.options.templates.userPMTemplate) : self.options.templates.userPMTemplate),
				pm      : (_.isString(self.options.templates.myPMTemplate) ? _.template(self.options.templates.myPMTemplate) : self.options.templates.myPMTemplate)
			};
			_.each(data, function (item, idx) {
				var elm;
				switch (dataType) {
					case 'user_pm':
						if (item.imgUrl) {
							var cssObj = self.options.customCssObjCreator(item.imgUrl, item.showClass);
							cssCreator.addCustomRule(item.showClass + self.options.customCssRuleSelectorSufix, cssObj);
						} else {
							cssCreator.makeRule(item.showClass);
						}
						break;
					case 'pm':
						item.hasNoClass = (item.showClass === 'cc_card' || item.showClass === 'dc_card') ? false : !cssCreator.makeRule(item.showClass);
						break;
				}
				if (isGroupMember || !item.groupId) {
					elm = _renderItem(item, dataType, itemContentTemplate[dataType]);
					_appendTo(parentElm, elm, self.options.direction)
				}
				if (item.isPmGroup && item.pm_list) {
					var df2 = $(document.createDocumentFragment()), ul;
					_listItems(df2, item.pm_list, dataType, true);
					ul = $(self.options.groupWrapTemplate)
						.attr('data-role', 'groupItemsHolder').addClass(constants.groupUlClassName)
						.append(df2);
					elm.attr('data-items', item.pm_list.length)
						.addClass('pms_wrap_' + item.pm_list.length);

					_appendTo(elm, ul, self.options.direction);
					_appendTo(elm, $(self.options.groupToggleIconTemplate).attr('data-role', 'group_icon'), self.options.direction);
				}
			});
		}

		var self = this;
		var dir = self.options.direction;
		var currentData = self.options[data_type + '_data'] || [];
		if (currentListElm) {
			currentListElm.find(self.options.itemContainerTagName + '[data-type="' + data_type + '"]').remove();
			var docFragment = $(document.createDocumentFragment());
			_listItems(docFragment, currentData, data_type);

			if ((data_type === 'pm' && dir === 'rtl') || (data_type === 'user_pm' && dir !== 'rtl')) {
				currentListElm.prepend(docFragment);
			} else {
				currentListElm.append(docFragment);
			}
		}
		if ((self.count_upm + self.count_pm) === 1) {
			self.$appleNav.addClass(constants.onlyOnePmClassName);
		} else {
			self.$appleNav.removeClass(constants.onlyOnePmClassName);
		}
	};

	function _appendTo(parentElm, elm, direction) {
		if (direction === 'rtl') {
			parentElm.prepend(elm);
		} else {
			parentElm.append(elm);
		}
	}

	function _prependTo(parentElm, elm, direction) {
		if (direction === 'rtl') {
			parentElm.append(elm);
		} else {
			parentElm.prepend(elm);
		}
	}

	function _setupControls (self) {
		var margin = self.options.scrollMargin;
		var duration = 1000;
		var easing = IScroll.utils.ease.quadratic;

		var showHideControls = function () {
			if (self.scroller) {
				self.scroller.refresh();
				var $scroll_wrapper = self.$element;
				if (self.scroller.scrollerWidth > $scroll_wrapper.width()) {
					self.$mainElement.find('.iscroll-controls-horizontal').show();
					if (self.options.staticControls) {
						$scroll_wrapper.addClass('iscroll-controls-static');
					}
				} else {
					self.$mainElement.find('.iscroll-controls-horizontal').hide();
					$scroll_wrapper.removeClass('iscroll-controls-static');
				}
			}
		};

		var buttonsState = function () {
			if (self.scroller) {
				self.scroller.refresh();
				var $left = self.$mainElement.find('.iscroll-controls-horizontal .left');
				var $right = self.$mainElement.find('.iscroll-controls-horizontal .right');
				if (self.scroller.x == 0) {
					$left.attr('disabled', true);
					$right.attr('disabled', false);
				}
				if (self.scroller.x > self.scroller.maxScrollX && self.scroller.x != 0) {
					$left.attr('disabled', false);
					$right.attr('disabled', false);
				}
				if (self.scroller.x == self.scroller.maxScrollX) {
					$left.attr('disabled', false);
					$right.attr('disabled', true);
				}
			}
		};

		self.updateControlButtons = function () {
			if (self.options.showControls) {
				showHideControls();
				buttonsState();
			}
		};

		self.$mainElement.on('click', '.iscroll-controls-horizontal .left', function () {
			if (self.scroller.x + self.scroller.wrapperWidth >= 0) {
				self.scroller.scrollTo(0, 0, duration, easing);
				self.$mainElement.find('.iscroll-controls-horizontal .left').attr('disabled', true);
				self.$mainElement.find('.iscroll-controls-horizontal .right').attr('disabled', false);
			} else {
				self.scroller.scrollBy(self.scroller.wrapperWidth - margin, 0, duration, easing);
			}
			self.$mainElement.find('.iscroll-controls-horizontal .right').attr('disabled', false);
		});

		self.$mainElement.on('click', '.iscroll-controls-horizontal .right', function () {
			if (self.scroller.x - self.scroller.wrapperWidth <= self.scroller.maxScrollX) {
				self.scroller.scrollTo(self.scroller.maxScrollX, 0, duration, easing);
				self.$mainElement.find('.iscroll-controls-horizontal .right').attr('disabled', true);
			} else {
				self.scroller.scrollBy(-self.scroller.wrapperWidth + margin, 0, duration, easing);
			}
			self.$mainElement.find('.iscroll-controls-horizontal .left').attr('disabled', false);
		});

		if (!self.$mainElement.find('.iscroll-controls-horizontal').length) {
			var controls = self.options.templates.controlsTemplate;
			self.$mainElement.append(controls);

			if (self.options.staticControls) {
				self.$element.addClass('iscroll-controls-static');
			}
		}

		showHideControls();
		buttonsState();
	}

	function _fixScrollBehavior(self) {
		self.$element.on('mouseleave touchend', function (e) {
			if (self.scroller) {
				if (e.type === 'mouseleave') {
					self.scroller.initiated = false;
				}
				if (0 < self.scroller.x || self.scroller.x < self.scroller.maxScrollX) {
					self.scroller.refresh();
				}
			}
		});
	}

	function _addScrollEndListener(self) {
		if (self.scroller && !self.scroller.isFake && !self.scroller._scrollEndEventAttached) {
			self.scroller._scrollEndEventAttached = true;
			self.scroller.on('scrollEnd', function () {
				if (0 < self.scroller.x || self.scroller.x < self.scroller.maxScrollX) {
					self.scroller.refresh();
				}
				self.updateControlButtons();
			});
		}
	}

	function _getUrl(metadata) {
		var url;
		if (metadata && metadata.imgContent && metadata.imgMimeType) {
			if (constants.supportedImageMimeType[metadata.imgMimeType]) {
				var normalizedString = (metadata.imgContent).replace(/(\r\n|\n|\r)/gm, "");
				url = ["data:", metadata.imgMimeType, ";base64,", normalizedString].join('');
			} else if (metadata.imgMimeType === constants.resourceTypeUrl) {
				url = metadata.imgContent.trim();
			}
		}
		return url;
	}

	function _createGroup(item) {
		return {
			uniqueId    : item.groupId,
			label       : item.groupLabel,
			name        : item.groupLabel,
			showClass   : (item.groupShowClass || item.groupLabel).toLowerCase(),
			isPmGroup   : true,
			isIframe    : false,
			details     : '',
			classPrefix : 'pm',
			pm_list     : [],
			$elm        : false,
			$elms       : false,
			groupId     : false,
			rawData     : {}
		}
	}

	function _handleApplePayClasses(self, data_type) {
		if (data_type !== "pm") {
			return;
		}
		if (self.hasApplePay && !self.options.showApplePayInline) {
			self.$mainElement.addClass(constants.hasApplePayOnTopClassName);
			self.$appleNav.removeClass('hidden');
		} else {
			self.$mainElement.removeClass(constants.hasApplePayOnTopClassName);
			self.$appleNav.addClass('hidden');
		}

		if (!self.options.showApplePayInline) {
			var $el = $(self.options.itemContainerTagName + '[data-value="ppp_ApplePay"]', self.wrapper);
			if ($el.length) {
				$el.css('display', 'none');
			}
		}
	}

    //DONE: OK
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, _, pubsub, cssCreator);


